/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.PollingLogFilter = (function() {

    /**
     * Namespace PollingLogFilter.
     * @exports PollingLogFilter
     * @namespace
     */
    var PollingLogFilter = {};

    PollingLogFilter.PollingLogFilterModel = (function() {

        /**
         * Properties of a PollingLogFilterModel.
         * @memberof PollingLogFilter
         * @interface IPollingLogFilterModel
         * @property {string|null} [applicationName] PollingLogFilterModel applicationName
         * @property {string|null} [companyId] PollingLogFilterModel companyId
         * @property {string|null} [dateFrom] PollingLogFilterModel dateFrom
         * @property {string|null} [dateTo] PollingLogFilterModel dateTo
         * @property {string|null} [sortColumn] PollingLogFilterModel sortColumn
         * @property {string|null} [sortOrder] PollingLogFilterModel sortOrder
         * @property {number|null} [pageIndex] PollingLogFilterModel pageIndex
         * @property {number|null} [pageSize] PollingLogFilterModel pageSize
         */

        /**
         * Constructs a new PollingLogFilterModel.
         * @memberof PollingLogFilter
         * @classdesc Represents a PollingLogFilterModel.
         * @implements IPollingLogFilterModel
         * @constructor
         * @param {PollingLogFilter.IPollingLogFilterModel=} [p] Properties to set
         */
        function PollingLogFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PollingLogFilterModel applicationName.
         * @member {string|null|undefined} applicationName
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.applicationName = null;

        /**
         * PollingLogFilterModel companyId.
         * @member {string|null|undefined} companyId
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.companyId = null;

        /**
         * PollingLogFilterModel dateFrom.
         * @member {string|null|undefined} dateFrom
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.dateFrom = null;

        /**
         * PollingLogFilterModel dateTo.
         * @member {string|null|undefined} dateTo
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.dateTo = null;

        /**
         * PollingLogFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.sortColumn = null;

        /**
         * PollingLogFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.sortOrder = null;

        /**
         * PollingLogFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.pageIndex = null;

        /**
         * PollingLogFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        PollingLogFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * PollingLogFilterModel _applicationName.
         * @member {"applicationName"|undefined} _applicationName
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_applicationName", {
            get: $util.oneOfGetter($oneOfFields = ["applicationName"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PollingLogFilterModel _companyId.
         * @member {"companyId"|undefined} _companyId
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_companyId", {
            get: $util.oneOfGetter($oneOfFields = ["companyId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PollingLogFilterModel _dateFrom.
         * @member {"dateFrom"|undefined} _dateFrom
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_dateFrom", {
            get: $util.oneOfGetter($oneOfFields = ["dateFrom"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PollingLogFilterModel _dateTo.
         * @member {"dateTo"|undefined} _dateTo
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_dateTo", {
            get: $util.oneOfGetter($oneOfFields = ["dateTo"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PollingLogFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PollingLogFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PollingLogFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PollingLogFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @instance
         */
        Object.defineProperty(PollingLogFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified PollingLogFilterModel message. Does not implicitly {@link PollingLogFilter.PollingLogFilterModel.verify|verify} messages.
         * @function encode
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @static
         * @param {PollingLogFilter.IPollingLogFilterModel} m PollingLogFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PollingLogFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.applicationName != null && Object.hasOwnProperty.call(m, "applicationName"))
                w.uint32(10).string(m.applicationName);
            if (m.companyId != null && Object.hasOwnProperty.call(m, "companyId"))
                w.uint32(18).string(m.companyId);
            if (m.dateFrom != null && Object.hasOwnProperty.call(m, "dateFrom"))
                w.uint32(26).string(m.dateFrom);
            if (m.dateTo != null && Object.hasOwnProperty.call(m, "dateTo"))
                w.uint32(34).string(m.dateTo);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(42).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(50).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(56).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(64).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified PollingLogFilterModel message, length delimited. Does not implicitly {@link PollingLogFilter.PollingLogFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @static
         * @param {PollingLogFilter.IPollingLogFilterModel} message PollingLogFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PollingLogFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PollingLogFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {PollingLogFilter.PollingLogFilterModel} PollingLogFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PollingLogFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PollingLogFilter.PollingLogFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.applicationName = r.string();
                    break;
                case 2:
                    m.companyId = r.string();
                    break;
                case 3:
                    m.dateFrom = r.string();
                    break;
                case 4:
                    m.dateTo = r.string();
                    break;
                case 5:
                    m.sortColumn = r.string();
                    break;
                case 6:
                    m.sortOrder = r.string();
                    break;
                case 7:
                    m.pageIndex = r.int32();
                    break;
                case 8:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a PollingLogFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof PollingLogFilter.PollingLogFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {PollingLogFilter.PollingLogFilterModel} PollingLogFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PollingLogFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return PollingLogFilterModel;
    })();

    return PollingLogFilter;
})();

module.exports = $root;
